module.exports = __webpack_public_path__ + "static/media/joker-static.05e9e3ae.png";